









import { Component, Vue } from 'vue-property-decorator';
import { Action, namespace } from 'vuex-class';
import TopNav from '../../components/TopNav.vue';

@Component({
  components: {
    TopNav,
  },
})
export default class Index extends Vue {
  
}
